
import React from 'react';
import { Card, CardContent } from '@/components/ui/card';

interface StepCardProps {
  title?: string;
  description?: string;
  children: React.ReactNode;
  className?: string;
}

const StepCard: React.FC<StepCardProps> = ({ 
  title, 
  description, 
  children,
  className = ""
}) => {
  return (
    <Card className={`bg-card/60 backdrop-blur-sm border-muted/40 ${className}`}>
      {(title || description) && (
        <div className="px-4 pt-3 pb-0">
          {title && <h3 className="text-base font-medium">{title}</h3>}
          {description && <p className="text-sm text-muted-foreground">{description}</p>}
        </div>
      )}
      <CardContent className="space-y-3 py-2 px-4">
        {children}
      </CardContent>
    </Card>
  );
};

export default StepCard;
